import { render, staticRenderFns } from "./DetallePedidoTienda.vue?vue&type=template&id=076135c2"
import script from "./DetallePedidoTienda.vue?vue&type=script&lang=js"
export * from "./DetallePedidoTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports